import { render, staticRenderFns } from "./TopUpsList.vue?vue&type=template&id=2cad35e3&scoped=true&"
import script from "./TopUpsList.vue?vue&type=script&lang=js&"
export * from "./TopUpsList.vue?vue&type=script&lang=js&"
import style0 from "./TopUpsList.vue?vue&type=style&index=0&id=2cad35e3&lang=scss&scoped=true&"
import style1 from "./TopUpsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad35e3",
  null
  
)

export default component.exports